import { theme } from 'antd'
import type { ThemeConfig } from 'antd'

// Single source of truth for all design tokens.
// Imported by App.tsx → ConfigProvider.
// CSS vars in enterprise.css :root must stay in sync with these values.
export const themeConfig: ThemeConfig = {
  algorithm: [theme.defaultAlgorithm],
  token: {
    // Brand colors — NetCell blue/navy (matches netcell-it.de homepage)
    colorPrimary:         '#2563EB',
    colorSuccess:         '#10B981',
    colorWarning:         '#F59E0B',
    colorError:           '#EF4444',
    colorInfo:            '#2563EB',

    // Typography
    fontFamily:           "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    fontSize:             14,
    fontSizeHeading1:     24,
    fontSizeHeading2:     20,
    fontSizeHeading3:     17,
    fontSizeHeading4:     15,
    fontSizeHeading5:     14,
    fontWeightStrong:     600,

    // Geometry — consistent 8-pt radius system
    borderRadius:         8,
    borderRadiusLG:       10,
    borderRadiusSM:       6,
    borderRadiusXS:       4,

    // Density — compact algorithm baseline + slight uplift for touch
    controlHeight:        30,

    // Surfaces & borders
    colorBgContainer:     '#FFFFFF',
    colorBgLayout:        '#F5F6FB',
    colorBorder:          '#E6E8F2',
    colorBorderSecondary: '#EEF0F7',
    colorText:            '#0F172A',
    colorTextSecondary:   '#64748B',
    colorTextTertiary:    '#94A3B8',
  },
  // NB: density/zebra and tighter cards are applied ONLY in enterprise.css under
  // `.admin-shell` — global component tokens here would also restyle the customer
  // portal (shared ConfigProvider), which must stay unchanged.
}
